import { yachSdk } from '../lib';
var defaultVersion = '0.0.0';
var defaultPlatform = {
  ios: {
    vs: defaultVersion
  },
  android: {
    vs: defaultVersion
  },
  pc: {
    vs: defaultVersion
  }
};
function initAPI(apiName, config) {
  var _config$params = config.params,
    params = _config$params === void 0 ? {} : _config$params,
    _config$platform = config.platform,
    platform = _config$platform === void 0 ? defaultPlatform : _config$platform;
  yachSdk.setAPI(apiName, platform);
  yachSdk.invokeAPI(apiName, params);
}
export default initAPI;


//////////////////
// WEBPACK FOOTER
// ./node_modules/yach.open.jssdk/es/api/initAPI.js
// module id = null
// module chunks = 